export default __webpack_public_path__ + "static/media/depositWithdrawalIcon7.1d004183.webp";